export const MUTUALS_COUNTER_DATA_TEST_ID = 'mutual-friends-counter'
